/** Código http que devuelve el backend en caso de código
 *  OTP incorrecto. */
export const ERROR_OTP_HTTP_CODE = 409;
/** Código http que devuelve el backend en caso de que el
 * usuario no esté registrado
 */
export const ERROR_NO_CLIENT_HTTP_CODE = 409;
export const ERROR_SERVER_HTTP_CODE = 500;
export const ERROR_INVALID_TOKEN = 401;
